<template>
  <div class="w-full flex items-center justify-center">
    <value-or-variable-with-label label='Layer' toggle-position='col' :value='value'>
      <template #default='{}'>
        <select v-model='lol'>
          <option v-for='layer in layerArray' :value='layer.id' :key='layer.id'>{{layer.name}} [{{layer.zindex}}]</option>
        </select>
      </template>
    </value-or-variable-with-label>
  </div>
</template>
<script>
import ValueOrVariableWithLabel from '@ui/molecules/ValueOrVariableWithLabel.vue';
export default {
  props:{
    value:{
      type:Number,
      required:true
    },
    layers:{
      type:Object,
      required:true
    }
  },
  methods: {
    onInput(nv, ov) {
      this.$emit("input", nv, ov);
      this.$emit("change", nv, ov);
    }
  },
  data() {
    return {
    }
  },
  computed:{
    lol:{
      get() {
        return this.value;
      },
      set(nv, ov) {
        this.onInput(nv, ov);
      }
    },
    layerIds() {
      return Object.keys(this.layers);
    },
    layerArray() {
      return Object.values(this.layers);
    }
  },
  components:{
    ValueOrVariableWithLabel
  }
}
</script>
